/*
 * SKRE Ambush Wader free-gear picker.
 * - Opens the gift picker when Ambush Waders are added to the cart.
 * - Adds the three chosen gifts (tagged with the hidden _skre_gift property).
 * - Keeps gift quantities <= wader quantity (removes gifts when waders are removed).
 * - Shows a "claim your free gear" reminder in the cart drawer and "FREE" on $0 lines.
 * Pricing itself is enforced by Shopify Buy X Get Y automatic discounts at checkout.
 */
(function () {
  if (window.SkreGift) return;

  var cfgEl = document.getElementById('SkreGiftConfig');
  var modal = document.getElementById('SkreGiftModal');
  if (!cfgEl || !modal) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }

  var WADER_VARIANTS = {};
  (cfg.waderVariantIds || []).forEach(function (id) {
    WADER_VARIANTS[String(id)] = true;
  });
  var GIFT_PROP = '_skre_gift';
  var GIFT_PROP_VALUE = 'SKRE Ambush Wader promo';
  var SOURCE = 'skre-gift';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_URL = (window.routes && window.routes.cart_url) || ROOT + 'cart';

  document.body.appendChild(modal);

  var items = Array.prototype.slice.call(modal.querySelectorAll('[data-skre-gift-item]'));
  var claimBtn = modal.querySelector('[data-skre-gift-claim]');
  var claimLabel = modal.querySelector('[data-skre-gift-claim-label]');
  var errorEl = modal.querySelector('[data-skre-gift-error]');
  var dialog = modal.querySelector('.skre-gift-modal__dialog');

  var lastCart = null;
  var lastFocus = null;
  var queue = Promise.resolve();

  /* ---------- helpers ---------- */

  function isWader(item) {
    return !!WADER_VARIANTS[String(item.variant_id)];
  }

  function isGiftLine(item) {
    return !!(item.properties && item.properties[GIFT_PROP]);
  }

  function itemAvailable(el) {
    var sel = el.querySelector('[data-skre-gift-select]');
    if (!sel) return false;
    return Array.prototype.some.call(sel.options, function (o) {
      return !o.disabled;
    });
  }

  function tally(cart) {
    var t = { wader: 0, claimed: {}, lines: {} };
    (cart.items || []).forEach(function (item) {
      if (isWader(item)) t.wader += item.quantity;
      if (isGiftLine(item)) {
        var pid = String(item.product_id);
        t.claimed[pid] = (t.claimed[pid] || 0) + item.quantity;
        (t.lines[pid] = t.lines[pid] || []).push(item);
      }
    });
    return t;
  }

  function missingCount(cart) {
    if (!cart) return 0;
    var t = tally(cart);
    if (!t.wader) return 0;
    return items.reduce(function (sum, el) {
      if (!itemAvailable(el)) return sum;
      var need = t.wader - (t.claimed[el.dataset.productId] || 0);
      return sum + Math.max(0, need);
    }, 0);
  }

  function getCart() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  function hasPubSub() {
    return typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  }

  function updateBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return Promise.resolve();
    return fetch(ROOT + '?sections=cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        var html = sections && sections['cart-icon-bubble'];
        if (!html) return;
        var section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
      })
      .catch(function () {});
  }

  // Re-render cart drawer / cart page after we change the cart ourselves.
  function refreshCartUI(cart) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active') && typeof drawer.renderContents === 'function') {
      return fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble')
        .then(function (r) {
          return r.json();
        })
        .then(function (sections) {
          drawer.renderContents({ sections: sections, id: null });
          var empty = !cart || cart.item_count === 0;
          drawer.classList.toggle('is-empty', empty);
          var inner = drawer.querySelector('.drawer__inner');
          if (inner) inner.classList.toggle('is-empty', empty);
          setTimeout(decorate, 50);
        })
        .catch(function () {});
    }
    if (hasPubSub()) publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: cart });
    return updateBubble();
  }

  /* ---------- enforcement: gifts can never exceed waders ---------- */

  function enforce(cart) {
    var t = tally(cart);
    var updates = {};
    var changed = false;
    Object.keys(t.lines).forEach(function (pid) {
      var allowed = t.wader;
      t.lines[pid].forEach(function (line) {
        var keep = Math.min(line.quantity, Math.max(0, allowed));
        allowed -= keep;
        if (keep !== line.quantity) {
          updates[line.key] = keep;
          changed = true;
        }
      });
    });
    if (!changed) return Promise.resolve({ cart: cart, changed: false });
    return postJSON(ROOT + 'cart/update.js', { updates: updates }).then(function (newCart) {
      return { cart: newCart && newCart.items ? newCart : cart, changed: true };
    });
  }

  /* ---------- modal ---------- */

  function setError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg || '';
    errorEl.hidden = !msg;
  }

  function syncModal(cart) {
    var t = tally(cart);
    items.forEach(function (el) {
      var need = t.wader - (t.claimed[el.dataset.productId] || 0);
      var picker = el.querySelector('[data-skre-gift-picker]');
      var status = el.querySelector('[data-skre-gift-status]');
      var done = need <= 0;
      if (!itemAvailable(el)) {
        if (status) {
          status.hidden = false;
          status.textContent = 'Sold out';
        }
        if (picker) picker.hidden = true;
        return;
      }
      if (status) {
        status.hidden = !done;
        status.textContent = 'In your cart';
      }
      if (picker) picker.hidden = done;
    });
    var label = 'Add my free gear';
    if (t.wader > 1) label += ' (' + t.wader + ' sets)';
    if (claimLabel) claimLabel.textContent = label;
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      closeModal();
      return;
    }
    if (e.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(
      dialog.querySelectorAll('button, select, [href], [tabindex]:not([tabindex="-1"])'),
      function (n) {
        return !n.disabled && n.offsetParent !== null;
      }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openModal(cart) {
    if (!cart || !missingCount(cart)) return;
    syncModal(cart);
    setError('');
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('skre-gift-open');
    document.addEventListener('keydown', onKeydown);
    setTimeout(function () {
      var firstSelect = modal.querySelector('[data-skre-gift-picker]:not([hidden]) select');
      (firstSelect || dialog).focus();
    }, 30);
  }

  function closeModal() {
    if (modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('skre-gift-open');
    document.removeEventListener('keydown', onKeydown);
    decorate();
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try {
        lastFocus.focus();
      } catch (e) {}
    }
  }

  function claim() {
    if (claimBtn.getAttribute('aria-busy') === 'true') return;
    claimBtn.setAttribute('aria-busy', 'true');
    setError('');

    run(function () {
      return getCart()
        .then(function (cart) {
          var t = tally(cart);
          if (!t.wader) {
            closeModal();
            return null;
          }
          var toAdd = [];
          var problem = '';
          items.forEach(function (el) {
            if (!itemAvailable(el)) return;
            var need = t.wader - (t.claimed[el.dataset.productId] || 0);
            if (need <= 0) return;
            var sel = el.querySelector('[data-skre-gift-select]');
            var opt = sel && sel.options[sel.selectedIndex];
            if (!opt || opt.disabled) {
              problem = 'Please choose an available color for each item.';
              return;
            }
            var props = {};
            props[GIFT_PROP] = GIFT_PROP_VALUE;
            toAdd.push({ id: Number(opt.value), quantity: need, properties: props });
          });
          if (problem) {
            setError(problem);
            return null;
          }
          if (!toAdd.length) {
            closeModal();
            return null;
          }
          var drawer = document.querySelector('cart-drawer');
          var body = { items: toAdd };
          if (drawer) {
            body.sections = 'cart-drawer,cart-icon-bubble';
            body.sections_url = window.location.pathname;
          }
          return postJSON(ROOT + 'cart/add.js', body).then(function (res) {
            if (res && res.status) {
              setError(
                (res.description || res.message || 'Something went wrong.') +
                  ' Try a different color, or contact us and we will make it right.'
              );
              return null;
            }
            closeModal();
            if (drawer && res && res.sections && typeof drawer.renderContents === 'function') {
              drawer.renderContents({ sections: res.sections, id: null });
              if (hasPubSub() && document.getElementById('main-cart-items')) {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE });
              }
            } else if (!drawer) {
              window.location.href = CART_URL;
              return null;
            }
            return getCart().then(function (c) {
              lastCart = c;
              setTimeout(decorate, 80);
            });
          });
        })
        .catch(function () {
          setError('Something went wrong adding your free gear. Please try again.');
        })
        .then(function () {
          claimBtn.removeAttribute('aria-busy');
        });
    });
  }

  /* ---------- cart drawer / cart page decoration ---------- */

  function zeroMoney(text) {
    var t = (text || '').trim();
    if (!/\d/.test(t)) return false;
    var digits = t.replace(/[^\d]/g, '');
    return /^0+$/.test(digits);
  }

  function decorate() {
    // "FREE" instead of $0.00 on discounted cart lines
    var selectors = [
      '.cart-item .cart-item__final-price',
      '.cart-item .cart-item__price-wrapper .price',
      '.cart-item .cart-item__discounted-prices .price',
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function (el) {
      if (el.dataset.skreFree) return;
      if (zeroMoney(el.textContent)) {
        el.dataset.skreFree = '1';
        el.textContent = 'FREE';
        el.classList.add('skre-free-label');
      }
    });

    // Reminder in the cart drawer / cart page when gifts are unclaimed
    var missing = missingCount(lastCart);
    var hosts = [];
    var drawerFooter = document.querySelector('cart-drawer .drawer__footer');
    if (drawerFooter) hosts.push(drawerFooter);
    var pageFooter = document.querySelector('#main-cart-footer .cart__blocks');
    if (pageFooter) hosts.push(pageFooter);
    hosts.forEach(function (host) {
      var existing = host.querySelector('.skre-gift-reminder');
      if (missing > 0) {
        if (existing) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'skre-gift-reminder';
        btn.innerHTML = '<span>Your free SKRE gear is waiting</span><span>Choose it</span>';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          openModal(lastCart);
        });
        host.insertBefore(btn, host.firstChild);
      } else if (existing) {
        existing.remove();
      }
    });
  }

  var decorateTimer = null;
  function scheduleDecorate() {
    clearTimeout(decorateTimer);
    decorateTimer = setTimeout(decorate, 60);
  }

  ['cart-drawer', '#main-cart-items', '#main-cart-footer'].forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el && 'MutationObserver' in window) {
      new MutationObserver(scheduleDecorate).observe(el, { childList: true, subtree: true });
    }
  });

  /* ---------- main loop ---------- */

  function run(task) {
    queue = queue.then(task, task);
    return queue;
  }

  function onCartChanged(event) {
    return run(function () {
      return getCart()
        .then(enforce)
        .then(function (result) {
          lastCart = result.cart;
          var p = result.changed ? refreshCartUI(result.cart) : Promise.resolve();
          return p.then(function () {
            var addedWader =
              event &&
              event.source === 'product-form' &&
              WADER_VARIANTS[String(event.productVariantId)];
            if (addedWader && missingCount(lastCart) > 0) openModal(lastCart);
            scheduleDecorate();
          });
        })
        .catch(function () {});
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === SOURCE) return;
      onCartChanged(event);
    });
  }

  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-skre-gift-close]')) {
      e.preventDefault();
      closeModal();
    }
  });
  claimBtn.addEventListener('click', claim);

  items.forEach(function (el) {
    var sel = el.querySelector('[data-skre-gift-select]');
    var img = el.querySelector('[data-skre-gift-img]');
    if (!sel || !img) return;
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      if (opt && opt.dataset.img) img.src = opt.dataset.img;
      setError('');
    });
  });

  window.SkreGift = {
    open: function () {
      return getCart().then(function (c) {
        lastCart = c;
        openModal(c);
      });
    },
    sync: function () {
      return onCartChanged(null);
    },
  };

  // Initial pass: trim any stray gifts and add the reminder if needed.
  onCartChanged(null);
})();